export const mockArticleCategorySearchResults = {
  total: 3,
  limit: 50,
  offset: 0,
  results: [
    {
      '@path':
        '/gb/domestic-and-general/self-fix/articles/how-to-fix/hoover-washing-machine-e03-error',
      articleTitle: 'Hoover error e03 - what it means and how to fix it',
    },
    {
      '@path':
        '/gb/domestic-and-general/self-fix/articles/how-to-fix/dishwasher-f70-error',
      articleTitle: 'My washing machine is leaking',
    },
    {
      '@path':
        '/gb/domestic-and-general/self-fix/articles/how-to-fix/Test-Article',
      articleTitle: 'Test Article ',
    },
  ],
};
